<template>
<div id="news" class="flex-c">
    <div class="swipe-wrap flex-self-ctr">
        <van-image :src="communityImg" width="10rem"></van-image>
    </div>
    <section>
        <van-tabs v-model="activeTab" sticky title-active-color="green" line-width="26" color="green" type="line" :border="tabBorder" @click="getNewsList">
            <van-tab title="新闻" name="新闻">
                <!-- 左文右图 -->
                <LeftAndRight />
            </van-tab>
        </van-tabs>
    </section>
</div>
</template>

<script>
import LeftAndRight from './../../components/LeftAndRight.vue'
export default {
    components: {
        LeftAndRight
    },
    data() {
        return {
            communityImg: require('@/assets/community.jpg'),
            activeTab: '新闻',
            tabBorder: false
        }
    },
    created() {
        this.$store.dispatch('changeNewType', {
            type: 3
        });
        this.$store.dispatch('changeNewCategory', {
            category: ''
        });
    },
    methods: {
        getNewsList(e) {
            window.console.log(e);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#news {
    .swipe-wrap {
        width: 750px;
        height: auto;
        overflow: hidden;
    }
}
</style>
